import { render, staticRenderFns } from "./collegeDelete.vue?vue&type=template&id=3ae1ae9e&"
import script from "./collegeDelete.vue?vue&type=script&lang=js&"
export * from "./collegeDelete.vue?vue&type=script&lang=js&"
import style0 from "./collegeDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports